var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container max-auto lg:w-full pb-40 md:relative"},[_c('search-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }